import {
  anInsight,
  anInsightHistoryEvent,
  mockInsightHistoryQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightHistoryQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: {
            ...anInsight(),
            history: [
              {
                ...anInsightHistoryEvent(),
                body: anInsightHistoryEvent().description,
              },
            ],
          },
        },
      });
    }
  ),
];
